
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import products from "../../data/products.json";
import "./ProductDetails.css";

const ProductDetails = () => {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [current, setCurrent] = useState(0);

  // Fetch product
  useEffect(() => {
    const foundProduct = products.find(
      (p) => p.product_id == Number(id)
    );
    setProduct(foundProduct);
  }, [id]);

  const images = product?.images || [];

  // Auto carousel
  useEffect(() => {
    if (images.length === 0) return;

    const interval = setInterval(() => {
      setCurrent((prev) =>
        prev === images.length - 1 ? 0 : prev + 1
      );
    }, 3000);

    return () => clearInterval(interval);
  }, [images.length]);

  // Safe return
  if (!product) return <div>Loading...</div>;

  // Excluded fields (don't show in table)
  const excludedFields = [
    "product_id",
    "id",
    "name",
    "images",
    "description",
  ];

  return (
    <div className="product-detail-container">

      <div className="carousel-section">
        <img src={images[current]} alt="product" />

        <div className="dots">
          {images.map((_, index) => (
            <span
              key={index}
              className={current === index ? "dot active" : "dot"}
              onClick={() => setCurrent(index)}
            />
          ))}
        </div>
      </div>

      <div className="details-section">
        <h3>{product.name}</h3>

        <table>
          <tbody>

            {Object.entries(product)
              .filter(
                ([key, value]) =>
                  !excludedFields.includes(key) &&
                  value !== "" &&
                  value !== null &&
                  value !== undefined
              )
              .map(([key, value]) => (
                <tr key={key}>
                  <td>
                    {key
                      .replace(/_/g, " ")
                      .replace(/\b\w/g, (char) =>
                        char.toUpperCase()
                      )}
                  </td>

                  <td style={{ whiteSpace: "pre-line" }}>
                    {Array.isArray(value)
                      ? value.join(", ")
                      : value}
                  </td>
                </tr>
              ))}

          </tbody>
        </table>

          <a
    href={`https://wa.me/919555264537?text=Hello%20Vetrieq,%20I%20would%20like%20to%20enquire%20about%20${product.name}`}
    target="_blank"
    rel="noopener noreferrer"
    className="enquire-btn"
  >
    Enquire Now <span className="enquire-arrow">↗</span>
  </a>

      </div>

    </div>
  );
};

export default ProductDetails;